export function setSortedFloorGroups(floors, floorId, floorGroups) {
  return floors.map((f) => {
    if (f.id === floorId) return { ...f, floorGroups };
    return f;
  });
}
